import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SupportTicketCreateModal from "./SupportTicketCreateModal";
import SupportTicketDetail from "./SupportTicketDetail";
import SupportTicketList from "./SupportTicketList";

function SupportTicketFullscreenModal({ show, onHide }) {
    const [selectedTicketId, setSelectedTicketId] = useState(null);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [reloadToken, setReloadToken] = useState(0);

    useEffect(() => {
        if (show) {
            setSelectedTicketId(null);
            setShowDetailModal(false);
            setShowCreateModal(false);
            setReloadToken(0);
        }
    }, [show]);

    const handleHide = () => {
        setSelectedTicketId(null);
        setShowDetailModal(false);
        setShowCreateModal(false);
        onHide?.();
    };

    const handleViewTicket = (ticketId) => {
        setSelectedTicketId(ticketId);
        setShowDetailModal(true);
    };

    const handleDetailHide = () => {
        setShowDetailModal(false);
        setSelectedTicketId(null);
        setReloadToken((value) => value + 1);
    };

    return (
        <Modal
            show={show}
            onHide={handleHide}
            fullscreen
            backdrop="static"
            dialogClassName="support-ticket-fullscreen-modal"
            contentClassName="support-ticket-fullscreen-modal-content"
        >
            <Modal.Header closeButton className="border-0 align-items-center">
                <Modal.Title className="fw-semibold me-3">
                    Support Tickets
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="support-ticket-modal-body p-0">
                <SupportTicketList
                    embedded
                    onViewTicket={handleViewTicket}
                    createOpen={showCreateModal}
                    onCreateOpenChange={setShowCreateModal}
                    reloadToken={reloadToken}
                />
            </Modal.Body>
            <SupportTicketCreateModal
                show={showCreateModal}
                onHide={() => setShowCreateModal(false)}
                onCreated={() => {
                    setShowCreateModal(false);
                    setReloadToken((value) => value + 1);
                }}
            />
            <Modal
                show={showDetailModal}
                onHide={handleDetailHide}
                fullscreen
                backdrop
                keyboard
                dialogClassName="support-ticket-detail-fullscreen-modal"
                contentClassName="support-ticket-fullscreen-modal-content"
            >
                <Modal.Header closeButton className="border-0 align-items-center">
                    <Modal.Title className="fw-semibold">Support Ticket Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body className="support-ticket-modal-body p-0">
                    {selectedTicketId ? (
                        <SupportTicketDetail ticketId={selectedTicketId} embedded />
                    ) : null}
                </Modal.Body>
            </Modal>
        </Modal>
    );
}

export default SupportTicketFullscreenModal;